import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";
import { getOrderingUnit } from "../../../http/api/MasterAPI";

const OrderingUnitSelect = ({ onChange, value }) => {
  const [listOrderingUnit, setListOrderingUnit] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || null);

  async function getListOrderingUnit() {
    try {
      const response = await getOrderingUnit();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderingUnitId: element.varCd,
          orderingUnitName: element.varValue1,
        }))
        .filter(
          (x) => x.orderingUnitName && x.orderingUnitName.trim() !== ""
        );
      setListOrderingUnit(result);
    } catch (error) {
      console.error("担当者を取得するとき不具合発生した。", error);
    }
  }

  useEffect(() => {
    getListOrderingUnit();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400 }}
      >
        <MenuItem key="unselected" value={null}>
          [未選択]
        </MenuItem>
        {listOrderingUnit.map((item) => (
          <MenuItem
            key={item.orderingUnitId}
            value={item.orderingUnitId}
          >
            {item.orderingUnitName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default OrderingUnitSelect;
